import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { useAuth } from '../../auth/AuthProvider';
function AdminNav(){
  const { perms } = useAuth();
  const can = (p:string)=>perms?.includes(p);
  return <nav className="p-4 border-b mb-4 flex gap-4 text-sm">
    {/* The admin dashboard and orders require the admin.read permission */}
    {can('admin.read') && <Link to="/admin/dashboard">Dashboard</Link>}
    {can('admin.read') && <Link to="/admin/orders">Orders</Link>}
    {/* Announcements management */}
    {can('admin.manage_announcements') && <Link to="/admin/announcements">Announcements</Link>}
    {/* User management */}
    {can('admin.manage_users') && <Link to="/admin/users">Users</Link>}
    {/* Invite management */}
    {can('admin.manage_invites') && <Link to="/admin/invites">Invites</Link>}
    {/* Courier credentials management */}
    {can('admin.manage_courier_creds') && <Link to="/admin/couriers">Couriers</Link>}
    {/* Finance pages are accessible to admins; specific actions are gated within the page */}
    {can('admin.read') && <Link to="/admin/finance">Finance</Link>}
    {/* Audit log */}
    {can('admin.view_audit') && <Link to="/admin/audit">Audit</Link>}
  </nav>;
}
export default function AdminLayout(){
  return <div className="container mx-auto">
    <h1 className="text-2xl font-semibold p-4">Admin</h1>
    <AdminNav />
    <Outlet />
  </div>;
}
